import { destroy } from 'redux-form';
import {
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';
import {
  loadAlumnoSuccess,
  loadCatalogoSuccess,
  LOAD_ALUMNO,
  LOAD_CATALOGO,
  SAVE_FILE,
  LOAD_DATA_NUCLEO,
  loadDataNucleoSuccess,
  setStudentAttribute,
  DESTROY_MATRICULAR_FORM,
  PROCESAR_MATIRCULA,
  procesarMatriculaSuccess,
  SAVE_DRAFT,
  saveDraftSuccess,
} from '../../redux/actions/matricularActions';
import {
  ROUTE_ALUMNO,
  ROUTE_CATALOGO,
  ROUTE_NUCLEO,
  ROUTE_MATRICULA,
  ROUTE_MATRICULA_DAY_CARE,
  ROUTE_NOTIFICACION,
  CICLO_LECTIVO_A_MATRICULAR,
} from '../../utils/constants';
import toAPIPath from '../../utils/locationResolver';
import {
  buildEnrollmentFinishedInternalNotificationEmail,
  buildEnrollmentFinishedNotificationEmail,
  buildStudentDataUpdatedInternalNotificationEmail
} from '../../utils/emailTemplates';

export function* getNucleoData(payload) {
  const { api, data } = payload;
  try {
    const nucleoData = yield call(api.get, toAPIPath([ROUTE_NUCLEO, `${data.nucleo}?filter=${encodeURIComponent('{"include": [{"relation":"telefono"},{"relation":"direccion"},{"relation":"medico"},{"relation":"encargado"},{"relation":"alumno"}]}')}&access_token=${data.token}`]));
    yield put(loadDataNucleoSuccess(nucleoData));
  } catch (err) {
    throw err;
  }
}

export function* getCatalogo(payload) {
  const { api, token, nucleo, isAdmin, alumnoId } = payload;
  try {
    const catalogo = yield call(api.get, toAPIPath([ROUTE_CATALOGO, `findOne?access_token=${token}`]));
    let nucleoId = nucleo;
    if (isAdmin) {
      const alumno = yield call(api.get, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]));
      nucleoId = alumno.nucleo;
    }
    yield call(getNucleoData, { api, data: { token, nucleo: nucleoId } });
    yield put(loadCatalogoSuccess(catalogo));
  } catch (err) {
    throw err;
  }
}

export function* getAlumno(payload) {
  const { api, data } = payload;
  try {
    const alumno = yield call(api.get, toAPIPath([ROUTE_ALUMNO, `${data.id}?access_token=${data.token}`]));
    yield all([
      'direccion',
      'contactoEmergencia',
      'medicoCabecera',
      'bitacora',
      'telefono',
      'encargado',
      'alergiasAlimenticias',
      'intoleranciasAlimenticias',
      'problemasGastrointestinales',
      'padecimientos',
      'medicamentos',
      'antecedentes',
      'alergiasMedicamentos',
      'limitacionesFisicas',
      'dietaEspecial',
    ].map(a => put(setStudentAttribute({
      attribute: a,
      value: alumno[a],
    }, true))));
    yield put(loadAlumnoSuccess(alumno));
  } catch (err) {
    throw err;
  }
}

export function* postArchivo(payload) {
  const { api, file, name, token } = payload;
  try {
    const formData = new FormData();
    formData.append('archivo', file, name);
    yield call(api.post, toAPIPath(['storage', 'dietaEspecial', `upload?access_token=${token}`]), formData);
  } catch (err) {
    throw err;
  }
}

export function* postArchivoRegistro(payload) {
  const { api, type, file, name, token } = payload;
  try {
    const formData = new FormData();
    formData.append('archivo', file, name);
    yield call(api.post, toAPIPath(['storage', type, `upload?access_token=${token}`]), formData);
  } catch (err) {
    throw err;
  }
}

export function* postMatricula(payload) {
  const { api, data } = payload;
  const { matricula, alumno, dietaEspecialForm, matriculaDayCare, token, isNew } = data;
  try {
    const appState = yield select(state => state.app);
    const usuario = appState.session.user.nombre;

    if (alumno.dietaEspecial) {
      yield call(postArchivo, {
        api, name: dietaEspecialForm.name, file: dietaEspecialForm.file, token,
      });
    }

    let alumnoId = alumno.id;
    delete alumno.id;

    if (isNew) {
      const newStudent = yield call(api.post, toAPIPath([`${ROUTE_ALUMNO}?access_token=${token}`]), alumno);
      alumnoId = newStudent.id;
    } else {
      const originalAlumno = yield call(api.get, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]));
      yield call(api.put, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]), alumno);

      const camposActualizados = Object.keys(alumno)
        .filter(key => originalAlumno[key] !== alumno[key])
        .join(', ');

      if (camposActualizados) {
        const notificacionActualizacion = buildStudentDataUpdatedInternalNotificationEmail(
          alumno,
          'asistente.direccion@weizmancr.net, recepcion@weizmancr.net, informatica@weizmancr.net',
          usuario,
          camposActualizados
        );
        yield call(api.post, toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]), notificacionActualizacion);
      } else {
        const notificacionWeizman = buildEnrollmentFinishedInternalNotificationEmail(alumno);
        yield call(api.post, toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]), notificacionWeizman);
      }
    }

    matricula.alumno = alumnoId;
    yield call(api.post, toAPIPath([`${ROUTE_MATRICULA}?access_token=${token}`]), matricula);

    if (matriculaDayCare) {
      matriculaDayCare.alumno = alumnoId;
      yield call(api.post, toAPIPath([`${ROUTE_MATRICULA_DAY_CARE}?access_token=${token}`]), matriculaDayCare);
    }

    const notificacionUsuario = buildEnrollmentFinishedNotificationEmail(alumno, appState.session.user.username, usuario);
    yield call(api.post, toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]), notificacionUsuario);

    yield put(procesarMatriculaSuccess());
  } catch (err) {
    throw err;
  }
}

export function* postDraft(payload) {
  const { api, data } = payload;
  const { alumno, dietaEspecialForm, token, isNew, nucleo, filesForms } = data;
  try {
    if (alumno.dietaEspecial) {
      yield call(postArchivo, {
        api, name: dietaEspecialForm.name, file: dietaEspecialForm.file, token,
      });
    }

    yield all(filesForms.map(f => call(postArchivoRegistro, {
      api, type: f.type, name: f.form.name, file: f.form.file, token,
    })));

    if (nucleo) {
      yield call(api.patch, toAPIPath([ROUTE_NUCLEO, `${alumno.nucleo}?access_token=${token}`]), nucleo);
    }

    let alumnoId = alumno.id;
    delete alumno.id;

    const originalAlumno = yield call(api.get, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]));

    if (isNew) {
      alumno.estadoMatricula = 'Pendiente';
      const newStudent = yield call(api.post, toAPIPath([`${ROUTE_ALUMNO}?access_token=${token}`]), alumno);
      alumnoId = newStudent.id;
    } else {
      yield call(api.put, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]), alumno);
    }


    if (alumno.estadoMatricula === `Matrícula ${CICLO_LECTIVO_A_MATRICULAR} Completa`) {

      const nuevoAlumno = yield call(api.get, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]));
      yield call(api.put, toAPIPath([ROUTE_ALUMNO, `${alumnoId}?access_token=${token}`]), alumno);

      const camposActualizados = Object.keys(nuevoAlumno)
        .filter(key => key !== 'bitacora' && !_.isEqual(originalAlumno[key], nuevoAlumno[key]))
        .join(', ');


      if (camposActualizados) {
        const appState = yield select(state => state.app);
        const usuario = appState.session.user.nombre;
        const notificacionActualizacion = buildStudentDataUpdatedInternalNotificationEmail(
          alumno,
          'asistente.direccion@weizmancr.net, recepcion@weizmancr.net, informatica@weizmancr.net',
          usuario,
          camposActualizados
        );
        yield call(api.post, toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]), notificacionActualizacion);
      } else {
        const notificacionWeizman = buildEnrollmentFinishedInternalNotificationEmail(alumno);
        yield call(api.post, toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]), notificacionWeizman);
      }

    }

    yield put(saveDraftSuccess(alumnoId));
  } catch (err) {
    throw err;
  }
}

export function* destroyForm(payload) {
  const { form } = payload;
  try {
    yield put(destroy(form));
  } catch (err) {
    console.error('An error occurred deleting the matricula form: ', err);
  }
}

export default function* rootSaga() {
  yield takeLatest(LOAD_CATALOGO, getCatalogo);
  yield takeLatest(LOAD_ALUMNO, getAlumno);
  yield takeLatest(LOAD_DATA_NUCLEO, getNucleoData);
  yield takeLatest(SAVE_FILE, postArchivo);
  yield takeLatest(DESTROY_MATRICULAR_FORM, destroyForm);
  yield takeLatest(PROCESAR_MATIRCULA, postMatricula);
  yield takeLatest(SAVE_DRAFT, postDraft);
}
